(function () {
  "use strict";

  if (window.customElements && window.customElements.get("qk-volume-order")) {
    return;
  }

  function parseInteger(value, fallback) {
    var parsed = Number.parseInt(String(value == null ? "" : value), 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function parseCents(value, fallback) {
    var parsed = Number.parseInt(String(value == null ? "" : value), 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getRootPath() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
    return root.endsWith("/") ? root : root + "/";
  }

  function formatMoney(cents, format) {
    var formatString = String(format || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || "${{amount}}");
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return "0";
      }

      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split(".");
      var amount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var decimals = parts[1] ? decimal + parts[1] : "";

      return amount + decimals;
    }

    var match = formatString.match(placeholderRegex);
    var token = match && match[1] ? match[1] : "amount";
    var value;

    switch (token) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function setFormattedMoney(element, cents, format) {
    if (!element) {
      return;
    }

    element.innerHTML = formatMoney(cents, format);
  }

  function normalizeBreaks(row) {
    var script = row.querySelector("[data-qk-volume-breaks]");
    var breaks = [];

    if (script) {
      try {
        breaks = JSON.parse(script.textContent || "[]");
      } catch (_error) {
        breaks = [];
      }
    }

    breaks = breaks
      .map(function (priceBreak) {
        return {
          minimumQuantity: parseInteger(priceBreak.minimumQuantity, 1),
          price: parseCents(priceBreak.price, 0),
        };
      })
      .filter(function (priceBreak) {
        return priceBreak.minimumQuantity > 0 && priceBreak.price >= 0;
      })
      .sort(function (a, b) {
        return a.minimumQuantity - b.minimumQuantity;
      });

    return breaks;
  }

  function alignQuantity(quantity, min, increment, max) {
    if (quantity <= 0) {
      return 0;
    }

    if (quantity < min) {
      quantity = min;
    }

    if (increment > 1) {
      quantity = min + Math.ceil((quantity - min) / increment) * increment;
    }

    if (max > 0 && quantity > max) {
      quantity = max;

      if (increment > 1 && quantity >= min) {
        quantity = min + Math.floor((quantity - min) / increment) * increment;
      }
    }

    return Math.max(0, quantity);
  }

  function getActiveBreak(breaks, quantity, fallbackPrice) {
    var activeBreak = {
      minimumQuantity: 1,
      price: fallbackPrice,
    };

    breaks.forEach(function (priceBreak) {
      if (quantity >= priceBreak.minimumQuantity) {
        activeBreak = priceBreak;
      }
    });

    return activeBreak;
  }

  class QkVolumeOrder extends HTMLElement {
    connectedCallback() {
      if (this._initialized) {
        return;
      }

      this._initialized = true;
      this.moneyFormat = this.getAttribute("data-money-format") || "";
      this.emptyMessage = this.getAttribute("data-empty-message") || "Selecteaza cel putin un produs.";
      this.successMessage = this.getAttribute("data-success-message") || "Produsele au fost adaugate in cos.";
      this.errorMessage = this.getAttribute("data-error-message") || "Nu am putut adauga produsele in cos.";
      this.addButton = this.querySelector("[data-qk-volume-add]");
      this.itemsElement = this.querySelector("[data-qk-volume-items]");
      this.subtotalElement = this.querySelector("[data-qk-volume-subtotal]");
      this.savingsRow = this.querySelector("[data-qk-volume-savings-row]");
      this.savingsElement = this.querySelector("[data-qk-volume-savings]");
      this.statusElement = this.querySelector("[data-qk-volume-status]");
      this.rows = Array.from(this.querySelectorAll("[data-qk-volume-row]")).map(this._hydrateRow.bind(this));

      this.rows.forEach(this._bindRow.bind(this));

      if (this.addButton) {
        this.addButton.addEventListener("click", this._addToCart.bind(this));
      }

      this._update();
    }

    _hydrateRow(row) {
      var min = Math.max(1, parseInteger(row.getAttribute("data-min"), 1));
      var increment = Math.max(1, parseInteger(row.getAttribute("data-increment"), 1));
      var max = parseInteger(row.getAttribute("data-max"), 0);
      var basePrice = parseCents(row.getAttribute("data-base-price"), 0);

      return {
        row: row,
        variantId: parseInteger(row.getAttribute("data-variant-id"), 0),
        disabled: row.classList.contains("is-disabled") || row.getAttribute("data-disabled") === "true",
        basePrice: basePrice,
        min: min,
        increment: increment,
        max: max,
        breaks: normalizeBreaks(row),
        input: row.querySelector("[data-qk-volume-input]"),
        decrementButton: row.querySelector("[data-qk-volume-decrement]"),
        incrementButton: row.querySelector("[data-qk-volume-increment]"),
        unitPriceElement: row.querySelector("[data-qk-volume-unit-price]"),
        compareElement: row.querySelector("[data-qk-volume-compare]"),
        discountElement: row.querySelector("[data-qk-volume-discount]"),
        lineTotalElement: row.querySelector("[data-qk-volume-line-total]"),
        tierElements: Array.from(row.querySelectorAll("[data-qk-volume-tier]")),
      };
    }

    _bindRow(item) {
      if (!item.input || item.disabled) {
        return;
      }

      if (item.decrementButton) {
        item.decrementButton.addEventListener("click", function () {
          this._setRowQuantity(item, this._decrementQuantity(item));
        }.bind(this));
      }

      if (item.incrementButton) {
        item.incrementButton.addEventListener("click", function () {
          this._setRowQuantity(item, this._incrementQuantity(item));
        }.bind(this));
      }

      item.input.addEventListener("change", function () {
        this._setRowQuantity(item, parseInteger(item.input.value, 0));
      }.bind(this));

      item.input.addEventListener("input", this._update.bind(this));
    }

    _getRowQuantity(item) {
      if (!item.input || item.disabled || item.input.disabled) {
        return 0;
      }

      return alignQuantity(parseInteger(item.input.value, 0), item.min, item.increment, item.max);
    }

    _setRowQuantity(item, quantity) {
      var normalizedQuantity = alignQuantity(quantity, item.min, item.increment, item.max);

      if (item.input) {
        item.input.value = String(normalizedQuantity);
      }

      this._clearStatus();
      this._update();
    }

    _incrementQuantity(item) {
      var currentQuantity = this._getRowQuantity(item);

      if (currentQuantity <= 0) {
        return item.min;
      }

      return currentQuantity + item.increment;
    }

    _decrementQuantity(item) {
      var currentQuantity = this._getRowQuantity(item);

      if (currentQuantity <= item.min) {
        return 0;
      }

      return currentQuantity - item.increment;
    }

    _updateRow(item) {
      if (item.disabled && item.input) {
        item.input.value = "0";
      }

      var quantity = this._getRowQuantity(item);
      var activeBreak = getActiveBreak(item.breaks, quantity, item.basePrice);
      var unitPrice = activeBreak.price;
      var lineTotal = quantity * unitPrice;
      var lineBaseTotal = quantity * item.basePrice;
      var savings = Math.max(0, lineBaseTotal - lineTotal);
      var discountPercent = item.basePrice > unitPrice
        ? Math.round((item.basePrice - unitPrice) * 100 / item.basePrice)
        : 0;

      if (item.unitPriceElement) {
        setFormattedMoney(item.unitPriceElement, unitPrice, this.moneyFormat);
      }

      if (item.lineTotalElement) {
        setFormattedMoney(item.lineTotalElement, lineTotal, this.moneyFormat);
      }

      if (item.compareElement) {
        item.compareElement.hidden = discountPercent <= 0;
        if (discountPercent > 0) {
          setFormattedMoney(item.compareElement, item.basePrice, this.moneyFormat);
        } else {
          item.compareElement.textContent = "";
        }
      }

      if (item.discountElement) {
        item.discountElement.hidden = discountPercent <= 0;
        item.discountElement.textContent = discountPercent > 0 ? "-" + discountPercent + "%" : "";
      }

      item.tierElements.forEach(function (tierElement) {
        var tierMin = parseInteger(tierElement.getAttribute("data-min"), 1);
        tierElement.classList.toggle("is-active", quantity > 0 && tierMin === activeBreak.minimumQuantity);
      });

      item.row.classList.toggle("has-quantity", quantity > 0);

      return {
        quantity: quantity,
        unitPrice: unitPrice,
        lineTotal: lineTotal,
        savings: savings,
      };
    }

    _update() {
      var totalQuantity = 0;
      var subtotal = 0;
      var savings = 0;

      this.rows.forEach(function (item) {
        var rowState = this._updateRow(item);
        totalQuantity += rowState.quantity;
        subtotal += rowState.lineTotal;
        savings += rowState.savings;
      }.bind(this));

      if (this.itemsElement) {
        this.itemsElement.textContent = String(totalQuantity);
      }

      if (this.subtotalElement) {
        setFormattedMoney(this.subtotalElement, subtotal, this.moneyFormat);
      }

      if (this.savingsElement) {
        setFormattedMoney(this.savingsElement, savings, this.moneyFormat);
      }

      if (this.savingsRow) {
        this.savingsRow.hidden = savings <= 0;
      }

      if (this.addButton) {
        this.addButton.disabled = totalQuantity <= 0 || this.addButton.getAttribute("aria-busy") === "true";
      }
    }

    _selectedItems() {
      return this.rows
        .map(function (item) {
          return {
            id: item.variantId,
            quantity: this._getRowQuantity(item),
          };
        }.bind(this))
        .filter(function (item) {
          return item.id > 0 && item.quantity > 0;
        });
    }

    _setBusy(isBusy) {
      if (!this.addButton) {
        return;
      }

      this.addButton.setAttribute("aria-busy", isBusy ? "true" : "false");
      this.addButton.disabled = isBusy || this._selectedItems().length === 0;
    }

    _setStatus(message, type) {
      if (!this.statusElement) {
        return;
      }

      this.statusElement.textContent = message || "";
      this.statusElement.dataset.status = type || "";
    }

    _clearStatus() {
      this._setStatus("", "");
    }

    _reset() {
      this.rows.forEach(function (item) {
        if (item.input) {
          item.input.value = "0";
        }
      });

      this._update();
    }

    async _dispatchCartChange() {
      try {
        var response = await fetch(getRootPath() + "cart.js", {
          credentials: "same-origin",
          headers: {
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (!response.ok) {
          return;
        }

        var cart = await response.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "qk:volume-order:add",
            cart: cart,
          },
        }));
      } catch (_error) {
        // The cart API response already succeeded; a stale cart badge is non-blocking.
      }
    }

    async _addToCart() {
      var items = this._selectedItems();

      if (!items.length) {
        this._setStatus(this.emptyMessage, "error");
        return;
      }

      this._setBusy(true);
      this._clearStatus();

      try {
        var response = await fetch(getRootPath() + "cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ items: items }),
        });
        var responseJson = await response.json().catch(function () { return {}; });

        if (!response.ok) {
          throw new Error(responseJson.description || responseJson.message || this.errorMessage);
        }

        this._reset();
        this._setStatus(this.successMessage, "success");
        await this._dispatchCartChange();
      } catch (error) {
        this._setStatus(error && error.message ? error.message : this.errorMessage, "error");
      } finally {
        this._setBusy(false);
        this._update();
      }
    }
  }

  window.customElements.define("qk-volume-order", QkVolumeOrder);
})();
